/**
 * Formats a hunt for profile "Last Hunt" display, e.g. "October 23 on Long Draw".
 */
export function formatLastHuntLine(hunt) {
  if (!hunt?.date) return null;

  const ymd = String(hunt.date).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;

  const [year, month, day] = ymd.split('-').map((part) => parseInt(part, 10));
  const dateObj = new Date(year, month - 1, day);
  const datePart = dateObj.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });

  const stand = (hunt.location || '').trim();
  if (!stand) return datePart;

  return `${datePart} on ${stand}`;
}

/**
 * Picks the most recent hunt from a list (by date, then id).
 */
export function pickMostRecentHunt(hunts) {
  const list = Array.isArray(hunts) ? hunts.filter((h) => h?.date) : [];
  if (!list.length) return null;

  return [...list].sort((a, b) => {
    const dateCmp = String(b.date).localeCompare(String(a.date));
    if (dateCmp !== 0) return dateCmp;
    return (b.id || 0) - (a.id || 0);
  })[0];
}
